
import { useEffect, useState } from "react";
import { useDebounceValue } from "@/hooks/use-debounce";
import { Input } from "@/components/ui/input";
import { Search, X } from "lucide-react";

interface ProductsSearchProps {
  onSearch: (query: string) => void;
  initialQuery?: string;
}

export function ProductsSearch({ onSearch, initialQuery = "" }: ProductsSearchProps) {
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [debouncedQuery] = useDebounceValue(searchQuery, 300);

  // Update search when debounced query changes
  useEffect(() => {
    onSearch(debouncedQuery);
  }, [debouncedQuery, onSearch]);

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="relative w-full">
      <Input
        type="text"
        placeholder="Search products, suppliers, tags, ingredients..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="pl-10 pr-10"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Search className="w-4 h-4 text-gray-400" />
      </div>
      {searchQuery && (
        <button
          onClick={handleClearSearch}
          className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
          aria-label="Clear search"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
